<template>
  <div class="container-simple-table">
    <div class="header-table">
      <div class="search-container">
        <feather
          class="refreshtable"
          :class="loadingtable === true ? 'animation-refresh' : 'stop'"
          type="refresh-cw"
          size="18px"
          @click="(!loadingtable) ? $emit('update-table', {limit:rowsperpage, offset: 0}) : null"
        />
        <search width="70%" height="35px" @searchtext="searchData($event)" />
      </div>
      <div class="left-side-container">
        <div class="select-rows-qt">
          <select
            v-model="rowsperpagechange"
            class="select-container"
            title="Selecionar quantidade de linhas"
            @change="rowsperpage = rowsperpagechange"
          >
            <option :value="10">
              10 Linhas -
              {{ `${userPageStatus} Até ${rowsperpageCustom} /` }}
              Total: {{ totalPages }}
            </option>
            <option :value="30">
              30 Linhas -
              {{ `${userPageStatus} Até ${rowsperpageCustom} /` }}
              Total: {{ totalPages }}
            </option>
            <option :value="50" selected>
              50 Linhas -
              {{ `${userPageStatus} Até ${rowsperpageCustom} /` }}
              Total: {{ totalPages }}
            </option>
            <option :value="100">
              100 Linhas -
              {{ `${userPageStatus} Até ${rowsperpageCustom} /` }}
              Total: {{ totalPages }}
            </option>
          </select>
        </div>
        <kfilter
          :filter-visibility="filterVisibility"
          @apply="filterVisibility = !filterVisibility,modalSendData()"
          @open-filter="filterVisibility = true"
          @clear="clearFilter()"
        >
          <template v-slot:container>
            <div class="dateselect-container">
              <b-checkbox v-model="initDate" size="is-small" class="checkbox-date">
                Data Início
              </b-checkbox>
            </div>

            <div v-if="initDate" class="date-box">
              <b-input
                v-model="initDateInput[0]"
                type="date"
                size="is-small"
                class="input-date-picker"
              />
              <b-input
                v-model="initDateInput[1]"
                type="date"
                size="is-small"
                class="input-date-picker"
              />
            </div>
          </template>
        </kfilter>
      </div>
    </div>

    <b-table
      :data="isEmpty ? [] : data"
      :selected.sync="selected"
      :total-pages="totalPages"
      :current-page="currentpage !== 0 && currentpage !== undefined ? currentpage : 1"
      :total="totalPages"
      :paginated="isEmpty === false ? true : false"
      :per-page="rowsperpage"
      pagination-size="is-small"
      :loading="loadingtable"
      focusable
      striped
      backend-pagination
      backend-sorting
      @sort="(orderby, direction) => modalSendData(orderby, direction)"
      @page-change="pagechange($event)"
    >
      <b-table-column
        v-slot="props"
        field="id"
        label="ID"
        width="40"
        header-class="custom-header"
        numeric
        sortable
      >
        <h1 :ref="'a' + props.row.id" class="row-text">
          {{ props.row.id }}
        </h1>
      </b-table-column>

      <b-table-column
        v-slot="props"
        field="sincronizacao_id"
        label="Sincronização ID"
        header-class="custom-header"
        sortable
      >
        <h1 class="row-text">
          {{ props.row.sincronizacao_id }}
        </h1>
      </b-table-column>

      <b-table-column
        v-slot="props"
        field="situacao"
        label="Situação"
        centered
        header-class="custom-header"
        sortable
      >
        <h1 class="row-text">
          {{ props.row.situacao }}
        </h1>
      </b-table-column>
      <b-table-column
        v-slot="props"
        field="tipo"
        header-class="custom-header"
        label="Tipo"
        sortable
      >
        <h1 class="row-text">
          {{ props.row.tipo }}
        </h1>
      </b-table-column>

      <b-table-column
        v-slot="props"
        field="dtinicio"
        header-class="custom-header"
        label="Data Início"
        sortable
      >
        <h1 class="row-text">
          {{ dateTimetoDate(props.row.dtinicio) }}
        </h1>
        <h2 class="table-subtitle">
          as {{ dateTimetoTime(props.row.dtinicio) }}
        </h2>
      </b-table-column>
      <b-table-column
        v-slot="props"
        sortable
        field="dtfim"
        header-class="custom-header"
        label="Data Fim"
      >
        <h1 class="row-text">
          {{ dateTimetoDate(props.row.dtfim) }}
        </h1>
        <h2 class="table-subtitle">
          as {{ dateTimetoTime(props.row.dtfim) }}
        </h2>
      </b-table-column>
    </b-table>
    <Empty
      v-if="data.length <= 0 && loadingtable === false"
      message="Nenhum item encontrado"
      subtitle="Tente alterar os filtros"
    />
  </div>
</template>

<script>
import kfilter from '../filter/custom';
import search from '../search/index';
import Empty from '../empty/index';
import 'vue-context/src/sass/vue-context.scss';
import global from '../../../mixins/global';

export default {
	components: {
		search,
		kfilter,
		Empty,
	},
	mixins: [global],
	props: {
		data: {
			type: Array,
			default: () => [],
		},
		loadingtable: {
			type: Boolean,
			default: true,
		},
		labels: {
			type: Array,
			default: () => [],
		},
		totalPages: {
			type: Number,
			default: 0,
		},
		currentpage: {
			type: Number,
			default: 1,
		},
	},

	data() {
		return {
			initDateInput: [],
			value: '',
			filterVisibility: false,
			initDate: false,
			rowsperpage: 50,
			rowsperpagechange: 50,
			rowsperpageCustom: '',
			userPageStatus: 0,
			lastpage: 1,
			pageRows: 0,
			selected: {},
			mytotalPages: 0,
			searchTerm: '',
		};
	},
	computed: {
		isEmpty() {
			if (this.data.length <= 0) {
				return true;
			}
			return false;
		},
	},
	watch: {
		rowsperpagechange() {
			this.pagechange(this.lastpage);
		},
		selected(e) {
			this.$nextTick(() => {
				this.focustTable(`a${e.id}`);
			});
		},
	},
	created() {
		const storage = localStorage.getItem('filter-integracoes') ?
			JSON.parse(localStorage.getItem('filter-integracoes')) : {};
		if (storage) {
			storage.searchTerm = '';
			localStorage.setItem('filter-integracoes', JSON.stringify(storage));
		}
		this.$emit('apply-modal', {
			limit: this.rowsperpage,
			offset: this.lastpage * this.rowsperpagechange - this.rowsperpagechange,
			page: this.lastpage,
		});
	},
	methods: {
		focustTable(refId = 'a139') {
			this.$refs[refId].scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
		},
		searchData(searchTerm) {
			this.searchTerm = searchTerm;
			const storage = localStorage.getItem('filter-integracoes') ?
				JSON.parse(localStorage.getItem('filter-integracoes')) : {};
			const filterDate = {
				direction: 'desc',
				orderby: 'dtinicio',
				dtinicio: this.initDateInput[0],
				dtfim: this.initDateInput[1],
				searchTerm,
			};
			if (storage.direction && storage.orderby) {
				filterDate.direction = storage.direction;
				filterDate.orderby = storage.orderby;
			}
			localStorage.setItem('filter-integracoes', JSON.stringify(filterDate));
			this.$emit('search-text', {
				offset: this.lastpage * this.rowsperpagechange - this.rowsperpagechange,
				limit: this.rowsperpagechange,
			});
		},
		clearFilter() {
			this.initDateInput = ['', ''];
			this.initDate = false;
			this.modalSendData();
		},
		modalSendData(orderby, direction) {
			const filterDate = {
				orderby,
				dtinicio: this.initDateInput[0],
				dtfim: this.initDateInput[1],
				direction,
				searchTerm: this.searchTerm,
			};
			localStorage.setItem('filter-integracoes', JSON.stringify(filterDate));
			this.$emit('apply-modal', {
				limit: this.rowsperpage,
				offset: this.lastpage * this.rowsperpagechange - this.rowsperpagechange,
				page: this.lastpage,
			});
			this.filterVisibility = false;
		},

		pagechange(pagenumber) {
			this.$emit(
				'pagechange',
				{
					searchTerm: this.searchTerm,
					dtinicio: this.initDateInput[0],
					dtfim: this.initDateInput[1],
					direction: 'asc',
					orderby: 'dtinicio',
					offset: pagenumber * this.rowsperpagechange - this.rowsperpagechange,
					limit: this.rowsperpagechange,
				},
				pagenumber
			);
			this.lastpage = pagenumber;
			this.rowsperpageCustom = pagenumber * this.rowsperpagechange + 1;
			this.userPageStatus = this.rowsperpageCustom - this.rowsperpagechange;
		},
		showmodal() {
			this.$emit('editaction', this.selected);
		},
		changeOption(e) {
			this.$emit('changeOption', e);
		},

		showContext(row, context) {
			this.selected = row;
			context.preventDefault();
			this.$refs.menu.open(context, row);
		},
	},
};
</script>

<style lang="scss" scoped>
.checkbox-date {
  width: 100%;
  padding: 10px 10px 10px 0px;
  border-bottom: 1px solid rgba(204, 204, 204, 0.411);
}
.date-box {
  display: flex;
}
.input-date-picker {
  width: 45%;
  font-size: 5px;
}
.input-date-picker:first-child {
  margin-right: 8px;
}
.dateselect-container {
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  animation: all 1s ease-in;
}
.dateselectinput:first-child {
  margin-right: 10px;
}
.empty {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  flex-direction: column;
  transition: 0.5s ease-in-out;
}
.select-rows-qt {
  margin-right: 20px;
}
.empty p {
  color: #25213b;
  font-weight: bold;
}
.img-empty {
  width: 35%;
}

.search-container {
  width: 60%;
  display: flex;
  align-items: center;
}

.refreshtable {
  margin-right: 20px;
  color: #00c9a7;
  cursor: pointer;
}

.animation-refresh {
  -webkit-animation: rotating 2s linear infinite;
  -moz-animation: rotating 2s linear infinite;
  -ms-animation: rotating 2s linear infinite;
  -o-animation: rotating 2s linear infinite;
  animation: rotating 2s linear infinite;
}

@keyframes rotating {
  from {
    -ms-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -ms-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
.container-simple-table {
  margin-bottom: 20px;
  background-color: #fff;
  padding: 13px;
  border-radius: 5px;
}
.select-container {
  all: unset;
  border-radius: 0.25rem;
  cursor: pointer;
  border: 1px solid #e2e2e2;
  padding-top: 7px;
  padding-bottom: 7px;
  padding-left: 15px;
  padding-right: 15px;
  font-size: 12px;
  color: rgb(98, 98, 98);
}

.span-rounded {
  width: 50px;
  height: 50px;
  background-color: #25213b;
}
.header-table {
  display: flex;
  width: 100%;
  background-color: #fff;
  justify-content: space-between;
  padding: 20px;
}
.left-side-container {
  display: flex;
}
.about-more {
  font-size: 12px;
  padding-left: 5px;
  padding-right: 5px;
  border-radius: 5px;
  color: #6e6893;
  font-weight: normal;
}

.int-id,
.email,
.user,
.id {
  font-size: 12px;
  font-weight: 400;
  color: #626262;
}

.row-text {
  display: flex;
  color: $row-color;
  font-weight: $row-weight;
  font-size: $row-size !important;
  margin-top: 5px;
  margin-bottom: 2px;
  font-size: 0.7rem;
}

.custom-header {
  font-size: $header-size;
  font-weight: $header-weight;
  color: $header-color;
}

/* .tag-status {

    color: #FFF;

} */

.is-success {
  display: flex;

  align-items: center;
}

.menu-row-icon {
  color: #8b83ba;

  padding-left: 10px;

  padding-right: 10px;

  font-weight: 500;
}

.menu-row-box-bottom {
  padding-top: 10px;
}

.menu-row-box {
  padding-bottom: 10px;

  border-bottom: 1px solid #f2f0f9;
}

.menu-row-option:first-child {
  margin-top: 5px;
}

.menu-row-option:hover {
  background-color: #f2f0f9 !important;

  color: #25213b !important;

  border-radius: 5px;
}

.menu-row-option:hover .danger {
  color: #dc3545 !important;
}

.menu-row-option:hover .check {
  color: #007f00;
}

.menu-row-option:hover .archive {
  color: #f77f00;
}

.menu-row-option {
  display: flex;

  align-items: center;

  margin-left: 5px;

  margin-right: 5px;

  padding: 10px;

  cursor: pointer;
}
</style>
>
